import React, { useEffect } from "react";
import "./css/DeltaLandingPage.css"; // Importa el archivo CSS
import { Box, Container } from "@mui/material";

// Asume que tienes la imagen del badge en la carpeta 'public' o la importas
const appStoreBadge = "/app-store-badge.png"; // O importa la imagen: import appStoreBadge from './assets/app-store-badge.png';
// const mockupImage = '/delta-internal-mockup.png'; // Descomenta si tienes un mockup

function DeltaLandingPage() {
	useEffect(() => {
		// Cambiar el título de la pestaña
		const originalTitle = document.title;
		document.title = "Delta";

		// Cambiar el favicon
		const favicon = document.querySelector('link[rel="icon"]');
		const originalFavicon = favicon.href;
		favicon.href = "/favicon_5.ico";

		// Revertir cambios al desmontar el componente
		return () => {
			document.title = originalTitle;
			favicon.href = originalFavicon;
		};
	}, []);
	const privacyPolicyUrl = "https://sosmuni.com/delta/privacidad"; // <-- REEMPLAZA ESTO
	const appStoreLink = "#"; // <-- REEMPLAZA CON TU ENLACE REAL DE APP STORE
	const contactEmail = "innova.msg@gmail.com";
	const orgInterestEmail = `mailto:${contactEmail}?subject=Interesado en Delta para mi organización`;
	const sosMuniUrl = "https://sosmuni.com"; // <-- REVISA SI ESTE ENLACE ES AÚN RELEVANTE

	return (
		<div className="landing-page-container">
			{" "}
			{/* Contenedor principal */}
			<header className="landing-header">
				<div className="container">
					<Box sx={{ mb: 3 }}>
						<img
							src="/images/logo/iosIcon.png" // Cambia esta ruta al logo real
							alt="Logo de Delta"
							style={{ maxWidth: "100px", height: "auto" }}
						/>
					</Box>
					<h1>Delta</h1>
					<p className="subtitle">
						La Herramienta Inteligente para el Reporte de Ocurrencias que
						necesitas
					</p>
					<p>
						Simplifica la forma en que tu equipo reporta incidencias internas.
						Envía informes con fotos, audio y texto directamente al grupo de
						trabajo correcto para una atención inmediata y eficiente.
					</p>

					{/* Llamadas a la Acción */}
					<div>
						<a
							href={appStoreLink}
							target="_blank"
							rel="noopener noreferrer"
							className="cta-button">
							Descargar Delta
						</a>
						<a href={orgInterestEmail} className="cta-button cta-secondary">
							¿Interesado para tu Organización?
						</a>
					</div>
					<span className="note">
						Requiere una cuenta proporcionada por tu organización participante.
					</span>

					{/* Mockup Opcional */}
					{/* <img src={mockupImage} alt="App Delta mostrando reporte interno" style={{ maxWidth: '350px', marginTop: '40px' }} /> */}
				</div>
			</header>
			<section id="benefits" className="landing-section">
				<div className="container">
					<h2>Agiliza tus Procesos Internos</h2>
					<div className="benefits">
						<div className="benefit-item">
							<div className="icon">⚡</div> {/* */}
							<h3>Rapidez y Facilidad</h3>
							<p>
								Reporta cualquier incidencia (mantenimiento, TI, logística,
								etc.) en segundos desde cualquier lugar con tu dispositivo
								móvil.
							</p>
						</div>
						<div className="benefit-item">
							<div className="icon">📄</div> {/* */}
							<h3>Informes Completos</h3>
							<p>
								Adjunta fotos, grabaciones de voz y descripciones detalladas
								para eliminar ambigüedades y acelerar la solución.
							</p>
						</div>
						<div className="benefit-item">
							<div className="icon">🎯</div> {/* */}
							<h3>Asignación Inteligente</h3>
							<p>
								El sistema dirige automáticamente cada reporte al equipo o
								persona responsable, evitando desvíos y demoras.
							</p>
						</div>
						<div className="benefit-item">
							<div className="icon">📊</div> {/* */}
							<h3>Seguimiento Claro</h3>
							<p>
								Visualiza el estado de tus reportes y recibe notificaciones
								sobre las actualizaciones y la resolución de las incidencias.
							</p>
						</div>
						<div className="benefit-item">
							<div className="icon">💬</div> {/* */}
							<h3>Comunicación Centralizada</h3>
							<p>
								Mantén toda la información sobre las ocurrencias en un solo
								lugar, accesible para los equipos involucrados.
							</p>
						</div>
						<div className="benefit-item">
							<div className="icon">⚙️</div> {/* */}
							<h3>Optimización Continua</h3>
							<p>
								Obtén datos sobre los tipos de ocurrencias y tiempos de
								respuesta para mejorar los procesos internos de tu organización.
							</p>
						</div>
					</div>
				</div>
			</section>
			<section id="features" className="landing-section">
				<div className="container">
					<h2>Funcionalidades Clave</h2>
					<ul className="features-list">
						<li>
							<strong>Reporte Multimedia:</strong> Crea informes detallados
							adjuntando fotos, notas de voz y descripciones de texto
							fácilmente.
						</li>
						<li>
							<strong>Enrutamiento Inteligente:</strong> Configura reglas para
							que cada tipo de ocurrencia sea asignada automáticamente al grupo
							de trabajo o departamento correcto.
						</li>
						<li>
							<strong>Notificaciones Push en Tiempo Real:</strong> Mantente
							informado al instante sobre la recepción, asignación y cierre de
							tus reportes, o recibe alertas importantes.
						</li>
						<li>
							<strong>Historial y Seguimiento:</strong> Accede a un listado de
							todas las ocurrencias reportadas, filtra por estado y revisa los
							detalles y actualizaciones.
						</li>
						<li>
							<strong>Interfaz Intuitiva:</strong> Diseño simple y fácil de usar
							para que todos puedan reportar sin complicaciones.
						</li>
						<li>
							<strong>Adaptable a tu Organización:</strong> Configurable para
							diferentes tipos de ocurrencias y estructuras de equipos.
						</li>
					</ul>
				</div>
			</section>
			<section id="who-is-it-for" className="landing-section who-is-it-for">
				<div className="container">
					<h2>¿Para Quién es Delta?</h2>
					<p style={{ maxWidth: "700px", margin: "0 auto" }}>
						{" "}
						{/* Ejemplo de estilo inline mantenido */}
						Delta es la solución perfecta para empresas, fábricas, instituciones
						educativas, hospitales, condominios, cadenas de tiendas, y cualquier
						organización que busque mejorar la eficiencia en la comunicación,
						reporte y gestión de sus incidencias internas.
					</p>
				</div>
			</section>
			<section id="privacy" className="landing-section privacy">
				<div className="container">
					<h2>Confidencialidad y Seguridad de Datos</h2>
					<p>
						La información gestionada a través de Delta se trata con estricta
						confidencialidad y se utiliza únicamente para los fines operativos
						internos de tu organización. Implementamos medidas de seguridad para
						proteger los datos.
					</p>
					<p>
						Cumplimos con las normativas de protección de datos aplicables. Para
						más información, consulta nuestra:
					</p>
					<p>
						<a
							href={privacyPolicyUrl}
							target="_blank"
							rel="noopener noreferrer"
							className="cta-button cta-secondary"
							style={{ borderColor: "#042D74", color: "#042D74" }}>
							Política de Privacidad
						</a>
					</p>
				</div>
			</section>
			<section id="download-cta" className="landing-section">
				<div className="container">
					<h2>Transforma la Gestión de ocurrencias</h2>
					<p>
						Empieza a usar Delta y mejora la comunicación y eficiencia de tus
						equipos.
					</p>
					<div>
						<a
							href={appStoreLink}
							target="_blank"
							rel="noopener noreferrer"
							className="cta-button">
							Descargar Delta
						</a>
						<a
							href={orgInterestEmail}
							className="cta-button cta-secondary"
							style={{ borderColor: "#042D74", color: "#042D74" }}>
							Solicitar Demo / Más Información
						</a>
					</div>
					<span
						className="note"
						style={{ color: "#555", marginTop: "20px", display: "block" }}>
						La descarga requiere una cuenta habilitada por tu organización.
					</span>
				</div>
			</section>
			<footer className="landing-footer">
				<div className="container">
					<p>
						<a
							href={privacyPolicyUrl}
							target="_blank"
							rel="noopener noreferrer">
							Política de Privacidad
						</a>{" "}
						|<a href={`mailto:${contactEmail}`}>Contacto / Soporte</a>
					</p>
					<p>
						&copy; {new Date().getFullYear()} Innova MSG. Todos los derechos
						reservados.
					</p>
				</div>
			</footer>
		</div>
	);
}

export default DeltaLandingPage;
